<template>
  <Row style="padding:20px">
    <div v-if="isLoad">
      <template v-for="(item, key) in getPostList">
        <Col :key="key" span="6">
          <Card :key="key">
            <div style="text-align:center">
              <img class="cardImg" src="">
              <router-link :to="item.author+'/'+item.permlink">
                <h5>
                  {{item.title}}
                </h5>
              </router-link>
            </div>
            <div class="cardFooter">
              <Col span="12">
                Price ? HBD
              </Col>
              <Col span="7" offset="5">
                <Icon class="like" type="ios-heart-outline" />
                <Icon class="shop" type="ios-basket" />
              </Col>
            </div>
          </Card>
        </Col>
      </template>
    </div>
    <div v-else>
      <Spin fix>
        <Icon type="ios-loading" size="18" class="spin-icon-load"/>
        <div>Loading</div>
      </Spin>
    </div>
  </Row>
</template>
<script>
export default {
  name: "Trending",
  props: {
    tag: {
      type: String,
      default: 'hi2peer'
    }
  },
  data() {
    return {
      postList: null
    }
  },
  computed: {
    isLoad() {
      return this.$store.getters.isLoad
    },
    getPostList() {
      return this.$store.getters.postList
    }
  },
  mounted() {
    let postList = { tag: this.tag, limit: 4 }
    this.$store.dispatch("getTrendingTag", postList)
  }
}
</script>
<style>
.title-post {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.cardFooter {
  padding: 20px;
}
.like {
  font-size: x-large;
  bottom: 2px;

}
.shop {
  left: 60px;
  float: left;
  position: relative;
  font-size: x-large;
  bottom: 2px;
}
.ivu-card-extra {
  top: auto !important;
  right: 5px !important;
  bottom: 10px;
  font-size: x-large;
}
.cardImg {
  width: 250px;
  height: 150px;
}
.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>